import { cpmConstants } from "../actions/actionTypes";
import { getConsents } from "services/cpm.service";
import { consentOptions } from "constants/PreferencesConst";
import { CPM_CONSENT_NO } from "constants/cpm";

export const loadConsents = (email) => async (dispatch) => {
  try {
    const response = await getConsents(email);
    const data = await response.json();
    dispatch(success(data));
  } catch (error) {
    if (error.response.status === 404) {
      let consents = { consents: [] };
      consentOptions.forEach((element) => {
        consents.consents.push({
          consent: CPM_CONSENT_NO,
          mission: element.key,
        });
      });
      dispatch(success(consents));
    } else {
      dispatch(failure());
    }
  }
};

function success(consents) {
  return {
    type: cpmConstants.CPM_SUCCESS,
    consents: consents,
  };
}

function failure(message) {
  return {
    type: cpmConstants.CPM_FAILURE,
    error: message,
  };
}
